import { useCallback } from "react";

const useWsRoleStatusHandler = ({
  setSelectedRoles,
  isRestoringArchive,
  setIsRestoringArchive,
  isRestoringArchiveRef,
  setIsMessageInputEnabled,
}) => {
  return useCallback((data) => {
    if (data.type !== "is_human") return false;

    console.log("收到角色状态:", data.is_human);
    const isHumanMap = data.is_human
      .replace(/map\[|\]/g, "")
      .split(" ")
      .reduce((acc, item) => {
        if (!item) return acc;
        const [key, value] = item.split(":");
        if (key && value) {
          acc[key] = value === "true";
        }
        return acc;
      }, {});

    console.log("解析后的角色状态:", isHumanMap);
    const humanRoleTypes = Object.keys(isHumanMap)
      .filter((key) => isHumanMap[key])
      .filter((type) => type);

    console.log("选中的角色 (类型):", humanRoleTypes);
    setSelectedRoles(humanRoleTypes);

    // 🔧 修复：在存档恢复模式下，不在这里处理恢复完成
    // 恢复完成的判断应该依赖于后端发送的 "项目存档恢复到前端" 消息
    // 而不是 is_human 消息，因为 is_human 可能在存档数据之前到达
    if (isRestoringArchiveRef.current) {
      console.log("🔄 存档恢复模式中，is_human 消息已处理，等待存档数据加载完成");
      // 不在这里重置恢复状态，由 useWsMessageHandlers 中的 "项目存档恢复到前端" 消息处理
    }

    return true;
  }, [
    isRestoringArchive,
    isRestoringArchiveRef,
    setIsMessageInputEnabled,
    setIsRestoringArchive,
    setSelectedRoles,
  ]);
};

export default useWsRoleStatusHandler;
